import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { Grid } from '../Grid';

import { Header } from '../Header';

import type {
  LayoutWithoutSidebarProps,
} from './types';

const StyledHeader = styled.div({
  position: 'relative',
  zIndex: 2,
});

const StyledContent = styled.div({
  position: 'relative',
  zIndex: 1,
});

export function LayoutWithoutSidebar({
  header,
  hasGrid = true,
  grid = undefined,

  counters = undefined,
  countersMaxNumber = undefined,

  children = undefined,
}: LayoutWithoutSidebarProps): ReactElement {
  return (
    <>
      <StyledHeader>
        <Header
          counters={counters}
          countersMaxNumber={countersMaxNumber}
          {...header}
          collapsible={false}
          withPusher
        />
      </StyledHeader>

      <StyledContent>
        {
          hasGrid ? (
            <Grid
              centered
              {...grid}
            >
              {children}
            </Grid>
          ) : children
        }
      </StyledContent>
    </>
  );
}
